// src/components/PrivateRoute.js
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children, roles }) => {
  const user = useSelector((state) => state.user.user);

  if (!user) {
    // User is not authenticated
    return <Navigate to="/dang-nhap" />;
  }

  const normalizedRole = String(user.role || "").toLowerCase();
  const normalizedRoles = (roles || []).map((r) => String(r || "").toLowerCase());
  const isAdminUser = user?.isAdmin === true || normalizedRole === "admin" || normalizedRole === "administrator";
  const isMemberUser = user?.isMember === true;
  const hasRequiredRole =
    !roles ||
    normalizedRoles.includes(normalizedRole) ||
    (normalizedRoles.includes("admin") && isAdminUser) ||
    (normalizedRoles.includes("admin") && isMemberUser) ||
    (normalizedRoles.includes("member") && isMemberUser);

  if (!hasRequiredRole) {
    // User does not have the required role
    return <Navigate to="/" />;
  }

  // User is authenticated and has the required role
  return children;
};

export default PrivateRoute;
